/**
 * Shared metadata cleaning utilities
 * DRY: Consolidates duplicate metadata cleaning logic
 */

/**
 * Remove undefined, null, and empty array values from metadata object
 * Mutates the object in place
 */
export const cleanMetadata = (metadata: Record<string, any>): void => {
  Object.keys(metadata).forEach((key) => {
    const value = metadata[key];
    if (value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
      delete metadata[key];
    }
  });
};
